// @flow
import * as React from 'react';
import 'common/styles/main.scss';
import 'react-virtualized/styles.css';
import 'react-grid-layout/css/styles.css';
import 'react-table/react-table.css';
import 'react-table-hoc-fixed-columns/lib/styles.css';
import { CommonProvider } from 'common/initialize';
import ErrorReporter from 'common/utils/ErrorReporter';
import MFETrackerService from 'common/services/MFETrackerService';
import EnvConfig from 'config';

import Root from './Root';

MFETrackerService.registerApp({
    name: 'container-dashboard',
    // eslint-disable-next-line no-undef
    version: __VERSION__,
    products: [],
    bugsnagApiKey: EnvConfig.bugsnagApiKey
});

ErrorReporter.initialize();

if (typeof pendo !== 'undefined') {
    pendo.TOOLTIP_ARROW_SIZE = 5; // setting pendo tooltip arrow size on load
}

const Shell = (): React.Node => {
    return (
        <CommonProvider>
            <Root />
        </CommonProvider>
    );
};

export default Shell;
